<script setup>
// X94 (Grant 2026-10-21: "In that time should be a radio select matching the UI with nothing initially selected and the
// confirm button disabled until it is"): the kit's bordered radio list (the memberships Cancel dialog's look), one row
// per choice with its sentence under it, nothing picked until the admin picks.
defineProps({
  /** [{value, title, sub}] */
  items: {type: Array, default: () => []},
  label: {type: String, default: null},
});
const model = defineModel({type: [String, Number, Boolean], default: null});
</script>

<template>
  <v-radio-group v-model="model" hide-details class="crl" :aria-label="label || undefined">
    <v-radio v-for="i in items" :key="String(i.value)" :value="i.value" color="primary" density="compact" class="crl-radio" :class="{'crl-radio--on': model === i.value}">
      <template #label>
        <span class="crl-body">
          <span class="crl-t">{{ i.title }}</span>
          <span v-if="i.sub" class="crl-s">{{ i.sub }}</span>
        </span>
      </template>
    </v-radio>
  </v-radio-group>
</template>

<style scoped lang="scss">
.crl {
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 12px;
  overflow: hidden;
}

.crl-radio {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px 10px;
  border-bottom: 1px solid rgb(var(--v-theme-borderLight));
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &--on {
    background: rgb(var(--v-theme-light));
  }
}

.crl-radio :deep(.v-label) {
  opacity: 1;
  flex: 1;
  min-width: 0;
}

.crl-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  padding-top: 4px;
}

.crl-t {
  font-size: 13.5px;
  font-weight: 600;
}

.crl-s {
  font-size: 12px;
  line-height: 1.5;
  color: rgb(var(--v-theme-textSubtle));
}
</style>
